import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { logger, analytics } from '@sendpayments/js-utils';

const useFeature = ({ feature, activeValue, functionName, defaultValue }) => {
  const flags = useFlags();
  const isEnabled = flags && flags[feature] === (activeValue || true);
  const notDefined = !flags || (flags && flags[feature] === undefined);

  useEffect(() => {
    logger.log(
      '@sendpayments/react-shared/components/FeatureActive',
      `Feature switch ${feature} is being used ${functionName ? ` by ${functionName}` : ''} and is ${
        !isEnabled ? 'inactive' : 'active'
      }`,
    );

    // Let analytics know what feature flags are coming through
    analytics.push({ featureFlags: flags });
  }, [isEnabled]);

  return [
    {
      data: {
        isEnabled: (notDefined && defaultValue) || isEnabled,
      },
    },
  ];
};

export default useFeature;
